
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.216.598A1.071 1.071 0 005.144 1.67v12.857a1.071 1.071 0 102.143 0V1.67A1.071 1.071 0 006.216.598zM1.93 7.027A1.071 1.071 0 00.858 8.098v6.429a1.071 1.071 0 102.143 0V8.098A1.071 1.071 0 001.93 7.027zM10.5 3.812A1.071 1.071 0 009.43 4.884v9.643a1.071 1.071 0 102.143 0V4.884A1.072 1.072 0 0010.5 3.812zm4.286 6.965a1.071 1.071 0 00-1.072 1.071v2.679a1.071 1.071 0 102.143 0v-2.679a1.072 1.072 0 00-1.071-1.071z","fill":"currentColor"}})])
          )
        }
      }
    